export default "__VITE_ASSET__BSpWAcUS__"